import { TDropItem } from 'src/types';

export const accreditedByOptions: TDropItem[] = [
  { value: 'departmentofdefense', label: 'Department of Defense' },
  { value: 'advanced', label: 'Cognia' },
  { value: 'middlestatesMSA', label: 'USRAA: Middle States Association of Colleges and Schools (MSA)' },
  { value: 'northcentralNCA', label: 'USRAA: North Central Association of Colleges and Schools (NCA)' },
  { value: 'southernSACS', label: 'USRAA: Southern Association of Colleges and Schools (SACS)' },
  { value: 'newenglandNEASC', label: 'USRAA: New England Association of Schools and Colleges (NEASC)' },
  {
    value: 'northwestNWAC',
    label: 'USRAA: Northwest Accreditation Commission (NWAC) /formerly Northwest Association of Accredited Schools',
  },
  { value: 'westernWASC', label: 'USRAA: Western Association of Schools and Colleges (WASC)' },
];
